import { useLocation } from "react-router-dom";
import { APP_PATHS } from "../../constants/paths";
import { BREADCRUMB_WRAPPER_ID } from "../../constants/reactPortal";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import DashboardHeader from "./DashboardHeader/DashboardHeader";
import DashboardFooter from "./DashboardFooter/DashboardFooter";
import classes from "./Layout.module.css";

const Layout = (props) => {
  const { children } = props;
  const { pathname } = useLocation();

  let content;
  switch (pathname) {
    case APP_PATHS.LANDING.url:
    case APP_PATHS.POLICY.url:
      content = (
        <>
          <Header />
          <main>{children}</main>
          <Footer />
        </>
      );
      break;
    case APP_PATHS.LOGIN.url:
      content = <main>{children}</main>;
      break;
    default:
      content = (
        <>
          <DashboardHeader />
          <main className={classes["layout__dashboard-main"]}>
            <div id={BREADCRUMB_WRAPPER_ID} />
            <div className={classes["layout__dashboard-content"]}>
              {children}
            </div>
          </main>
          <DashboardFooter />
        </>
      );
  }

  return <div className={classes["layout"]}>{content}</div>;
};

export default Layout;
